import React, { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { getBalanceChangeRecords } from '../../api'
import {
    BALANCE_CHANGE_RECORD_TYPE_LIST,
    BALANCE_CHANGE_RECORD_TYPE_MAP,
    getBalanceChangeAmount,
    getCombinedBalanceText,
    formatDateTime,
    getOperatorName,
    getShopName,
    RECORD_PAGE_SIZE,
} from './record-utils'
import MemberRecordTable from './record-table'

interface Props {
    memberId: number
}

const BalanceChange: React.FC<Props> = props => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(RECORD_PAGE_SIZE)
    const req = useRequest(
        () =>
            getBalanceChangeRecords({
                member_id: props.memberId,
                page,
                limit: pageSize,
                record_type_list: BALANCE_CHANGE_RECORD_TYPE_LIST,
            }),
        {
            refreshDeps: [props.memberId, page, pageSize],
            onError: e => $msg('error', e.message || '获取余额变动失败'),
        },
    )
    const columns: ColumnsType<any> = [
        { title: '时间', dataIndex: 'create_time', width: 170, render: formatDateTime },
        {
            title: '变动类型',
            dataIndex: 'record_type',
            width: 140,
            render: value => BALANCE_CHANGE_RECORD_TYPE_MAP[value] || '-',
        },
        { title: '店铺', dataIndex: 'shop', width: 160, render: getShopName },
        { title: '订单号', dataIndex: 'order_no', width: 220, render: value => value || '-' },
        {
            title: '变动金额',
            width: 220,
            render: record => getBalanceChangeAmount(record.record_type, record.changed_amount, record.changed_bonus),
        },
        {
            title: '变动后金额',
            width: 220,
            render: record => getCombinedBalanceText(record.remain_amount, record.remain_bonus),
        },
        { title: '操作员', dataIndex: 'creator', width: 112, render: getOperatorName },
    ]

    return (
        <MemberRecordTable
            rowKey={(record, index) => record.id || index}
            loading={req.loading}
            columns={columns}
            dataSource={req.data?.balance_record_list || []}
            page={page}
            pageSize={pageSize}
            pagination={req.data?.pagination}
            onPageChange={setPage}
            onPageSizeChange={(nextPage, nextSize) => {
                setPage(nextPage)
                setPageSize(nextSize)
            }}
        />
    )
}

export default BalanceChange
